import type { UIStructure } from "../types";
export const es: UIStructure = {
  onboarding: {
    name: {
      title: "Vamos a conocerte. ¿Cuál es tu nombre?",
      description: "¡Así que sabemos cómo dirigirnos a usted!",
      button: "Continuar",
    },
    zipcode: {
      title: "Hola {{name}}, ¿cuál es tu código postal?",
      description:
        "Le pedimos el código postal para poder encontrar lo que está disponible en su área.",
      button: "Continuar",
    },
    email: {
      title: "¡Genial! ¿Cuál es tu dirección de correo electrónico?",
      description:
        "Utilizaremos su correo electrónico para enviarle actualizaciones importantes e información sobre su elegibilidad para los beneficios.",
      button: "Continuar",
    },
    partnerMember: {
      title: "¿Es usted actualmente miembro de {{partnerName}}?",
      optIn:
        "¿Estaría interesado en otras formas en las que {{partnerName}} puede ayudarlo en su viaje financiero?",
      switcher: "Sí, me interesaría.",
      button: "Continuar",
    },
    householdSize: {
      title: "¿Cuántas personas viven en tu casa?",
      description:
        "¡El tamaño de su hogar incluye a su cónyuge, hijos o dependientes que viven con usted, además de usted mismo!",
      placeholder: "Introduzca el número de personas en su hogar",
      button: "Continuar",
    },
    householdIncome: {
      title: "¿Cuál es su ingreso familiar anual antes de impuestos?",
      description: "¡Su mejor conjetura está bien!",
      placeholder: "Introducir número",
      suffix: "por año",
      button: "Continuar",
    },
    householdAges: {
      title: "¿Qué edad tienen los miembros de su hogar?",
      description:
        "Preguntar la edad nos ayuda a saber a qué recursos puede calificar su familia.",
      label: "¿Qué edad tiene el {{index}} miembro del hogar?",
      placeholder: "Edad del miembro del hogar número {{index}}",
      button: "Continuar",
    },
    preferences: {
      title: "¿Qué programas le interesan?",
      description: "¡Nos gustaría saber qué programas le interesan!",
      interestedProgramTypesLabel: "Tipos de programas",
      freeformResponseLabel:
        "Otros programas de beneficios que le gustaría explorar",
      button: "Continuar",
    },
  },
  landingPage: {
    howItWorks: {
      title: "Cómo Funciona",
      step1: {
        title: "Verificar elegibilidad",
        description:
          "Determine fácilmente su elegibilidad para recibir beneficios y cuánto puede ahorrar.",
      },
      step2: {
        title: "Obtenga orientación personalizada",
        description:
          "Obtenga orientación paso a paso sobre cómo presentar la solicitud.",
      },
      step3: {
        title: "Continúe su viaje financiero",
        description:
          "Obtenga apoyo en el siguiente paso de su futuro financiero.",
      },
    },
    mailingListForm: {
      title:
        "{{partnerName}} está aquí para empoderarle en su camino financiero.",
      description: "Para mantenerse conectado, ingrese su correo electrónico",
      button: "Continuar",
      successMessage: "¡Gracias por registrarse!",
    },
    zipCodeForm: {
      placeholder: "Ingrese el código postal",
      button: "Comenzar",
    },
    hero: {
      title: "Acceso a Beneficios con {{partnerName}}",
      subtitle: "Un buscador de beneficios para ayudarle a",
      subtitleHilight: "ahorrar",
      callToAction: "Descubra cómo puede",
      callToActionHighlight:
        "ahorrar en salud, alimentos, servicios públicos, cuidado infantil y más.",
    },
  },
  about: {
    title: "Acerca de {{partnerName}}",
  },
  general: {
    copyright: " Starlight. Todos los derechos reservados.",
    navigation: {
      label: "Menú Principal",
      hub: "Centro de Beneficios",
      profile: "Mi Perfil",
      faq: "Preguntas Frecuentes",
      about: "Acerca de",
      signOut: "Cerrar Sesión",
    },
    privacyPolicy: "Política de Privacidad",
    poweredBy: "Impulsado por",
    terms: "Términos y Condiciones",
    back: "Atrás",
    next: "Siguiente",
    continue: "Continuar",
    backToHub: "Volver al Centro",
    yes: "Sí",
    no: "No",
    header: {
      login: "¿Ya tienes una cuenta?",
      button: "Iniciar sesión",
    },
  },
  hub: {
    savingsCallOut:
      "Solicitar los beneficios a continuación podría otorgarle hasta",
    savingsCallOutFrequency: "mensualmente",
    questionsButton: "¿Preguntas? Hable con un especialista en beneficios",
    title: "Beneficios Para Usted",
    subtitle:
      "Basado en su información hasta ahora, encontramos los siguientes beneficios.",
    titleUnavailable: "¡Próximamente en su área!",
    subtitleUnavailable:
      "Aún no estamos en su área, pero estamos felices de ayudarle mientras tanto.",
    descriptionUnavailable:
      "Nuestro equipo puede asistirle manualmente con cualquier pregunta o guía que necesite. Simplemente contáctenos a través del botón de soporte por chat a continuación.",
  },
  auth: {
    signIn: {
      title: "Su Red de Seguridad Financiera",
      subtitle: "Comencemos.",
      description:
        "Estamos aquí para ayudarle a acceder a programas de beneficios para salud, alimentos, servicios públicos y más.",
      callToAction: "¿Necesita crear una cuenta?",
      signUp: "Regístrese",
      footerText:
        "Recibirá un mensaje de texto para verificar su número de teléfono. Su privacidad es nuestra máxima prioridad. Conozca más sobre nuestra",
      error: {
        title: "Error al iniciar sesión",
        description: "Por favor, regresa a la",
        previous: "página anterior",
        description2: "e inténtalo de nuevo",
      },
      phoneVerify: {
        title: "Por favor, ingresa el código enviado a {{phone}}",
        button: "Verificar",
      },
    },
    signUp: {
      titleZipCode: "Bienvenido al Centro de Beneficios de {{partnerName}}",
      titleBenefits: "Hemos encontrado",
      titleBenefitsHighlight: "{{programCount}} beneficios",
      titleBenefits2: "en su área que podrían ayudarle a ahorrar.",
      titleUnavailable: "Aún no estamos disponibles en su área.",
      descriptionBenefits:
        "Regístrese abajo y comience a hacer estos ahorros realidad.",
      descriptionUnavailable:
        "Aún puede registrarse abajo y le notificaremos cuando los beneficios estén disponibles.",
      disclaimer: "Al registrarse, acepta nuestros",
      andThe: "y los",
      phoneVerify: {
        title: "Ingresa tu número de teléfono",
        description:
          "Te enviaremos un PIN de 6 dígitos por mensaje de texto para garantizar tu seguridad.",
        button: "Registrarse",
      },
    },
  },
  programs: {
    successQuestion: "¿Pudo completar su solicitud exitosamente? ¡Cuéntenos!",
    title: "Inicie su solicitud para {{programName}}",
    description: "Le guiaremos a través de los siguientes pasos.",
    step: "paso",
    program: {
      title: "Solicitar {{programName}}",
      cardTitle: "¿Desea una estimación más precisa?",
      cardDescription:
        "¡Responda unas pocas preguntas más para ver si puede calificar para más!",
      applyButton: "Aprenda cómo aplicar",
      cardSavings: "Su ahorro estimado: hasta {{savings}}/mes",
      cardNonEligible:
        "Es posible que no sea elegible, pero aún puede aprender más sobre este programa.",
    },
    savings: {
      titleSuccess: "¡Podría ser elegible para {{savings}} al mes!",
      titleFail: "Es posible que no sea elegible para este programa.",
      descriptionSuccess:
        "Basándonos en su información, como ingresos y tamaño de la familia, podría recibir hasta {{savings}} al mes.",
      descriptionFail:
        "Basándonos en su información, como ingresos y tamaño de la familia, es posible que no sea elegible para este programa, ¡pero aún puede ver nuestra guía!",
      howApply: "Ver cómo aplicar",
    },
  },
  requiredFields: {
    title: "Algunas preguntas para determinar cuánto podría ahorrar...",
    adultHealthPremium: {
      label: "¿Cuánto paga por su seguro de salud cada mes?",
    },
    annualIncome: {
      label: "¿Cuál es su ingreso anual?",
    },
    cancer: {
      label: "¿Tiene cáncer?",
    },
    childCareCost: {
      label: "¿Cuál es el costo mensual del cuidado infantil?",
    },
    childCareHours: {
      label: "¿Cuántas horas de cuidado infantil necesita por semana?",
    },
    childHealthPremium: {
      label: "¿Cuánto paga por el seguro de salud de su hijo cada mes?",
    },
    childSupportExpense: {
      label: "¿Cuánto paga en manutención infantil cada mes?",
    },
    childSupportIncome: {
      label: "¿Cuánto recibe de manutención infantil cada mes?",
    },
    ssdiAmount: {
      label: "¿Cuál es el monto mensual de su SSDI?",
    },
    employerSubsidizedHealthcare: {
      label: "¿Recibe atención médica subsidiada por su empleador?",
    },
    feedFamilyCost: {
      label: "¿Cuál es el costo mensual para alimentar a su familia?",
    },
    filingJointly: {
      label: "¿Presenta impuestos de manera conjunta?",
    },
    foodStamps: {
      label: "¿Cuánto recibe en SNAP/vales de alimentos cada mes?",
    },
    fullTimeStudent: {
      label: "¿Es estudiante a tiempo completo?",
    },
    giIncome: {
      label: "¿Cuál es su ingreso por GI?",
    },
    grReceiving: {
      label: "¿Recibe GR?",
    },
    homeless: {
      label: "¿Actualmente vive sin una dirección permanente?",
    },
    housingCosts: {
      label: "¿Cuáles son sus costos de vivienda mensuales?",
    },
    kinshipFamily: {
      label: "¿Forma parte de una familia de parentesco?",
    },
    lifeline: {
      label: "¿Recibe lifeline?",
    },
    livingApart: {
      label: "¿Vive separado de su cónyuge?",
    },
    mainHouseChild: {
      label: "¿Tiene un hijo en la casa principal?",
    },
    medicaid: {
      label: "¿Está inscrito en Medicaid?",
    },
    married: {
      label: "¿Está casado/a?",
    },
    ssiChildrenNumber: {
      label: "¿Cuántos hijos tiene en SSI?",
    },
    otherIncome: {
      label: "¿Cuánto ingreso adicional recibe cada mes?",
    },
    pregnant: {
      label: "¿Está embarazada?",
    },
    schoolLunch: {
      label:
        "¿Sus hijos reciben almuerzo escolar gratuito o a precio reducido?",
    },
    ssiSpouseAmount: {
      label: "¿Cuál es el monto de SSI de su cónyuge?",
    },
    ssiYouAmount: {
      label: "¿Cuál es el monto de su SSI?",
    },
    ssiKidsAmount: {
      label: "¿Cuál es el monto de SSI de sus hijos?",
    },
    ssiOver65: {
      label: "¿Tiene 65 años o más y recibe SSI?",
    },
    studentSnapExemptions: {
      label: "¿Tiene alguna exención de SNAP para estudiantes?",
    },
    unemploymentAmount: {
      label: "¿Cuál es el monto de su beneficio por desempleo?",
    },
    unemployed: {
      label: "¿Está actualmente desempleado/a?",
    },
    utilitiesInName: {
      label: "¿Están los servicios públicos a su nombre?",
    },
    welfareAmount: {
      label: "¿Cuál es el monto de su asistencia social?",
    },
    workStudyAmount: {
      label: "¿Recibe ingresos como estudiante de trabajo-estudio?",
    },
    downPaymentContributionAmount: {
      label: "¿Cuánto puede contribuir a un pago inicial?",
    },
    isFirstTimeHomeBuyer: {
      label:
        "¿Es comprador/a de vivienda por primera vez? (Esto significa que no ha sido propietario/a de una vivienda en al menos tres años)",
    },
    ownerOccupied: {
      label: "¿Vivirá en la casa que compre?",
    },
  },
  benefits: {
    availableBenefits: "Beneficios Disponibles",
    food: {
      title: "Alimentos",
      description:
        "Descubra su elegibilidad para SNAP, WIC y bancos de alimentos locales.",
    },
    healthcare: {
      title: "Salud",
      description: "Averigüe si califica para Medicaid y planes ACA.",
    },
    housing: {
      title: "Vivienda",
      description:
        "Obtenga ayuda con el alquiler y programas de asistencia para el pago inicial.",
    },
    utilities: {
      title: "Servicios Públicos",
      description:
        "Verifique la elegibilidad para HEAP y programas de asistencia con facturas de servicios públicos.",
    },
    childcare: {
      title: "Cuidado Infantil",
      description:
        "Acceda a asistencia para cuidado infantil y programas de educación temprana.",
    },
    taxCredits: {
      title: "Créditos Fiscales",
      description:
        "Vea si califica para EITC, Crédito Tributario por Hijos y otros beneficios fiscales.",
    },
    jobSupport: {
      title: "Apoyo Laboral",
      description: "Infórmese sobre el seguro de desempleo.",
    },
    otherSupport: {
      title: "Otros Apoyos",
      description:
        "Encuentre servicios para personas mayores, asistencia con facturas médicas y más.",
    },
  },
};
